import "./styles.css";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import {
    collection,
    getDocs,
    query,
    where,
    orderBy,
} from "firebase/firestore";
import { db } from "../../utils/firebase";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect, useState, useRef } from "react";
import "./styles.css";
import moment from "moment";

const ExpenseLineChart = () => {
    const { currentUser } = useAuth();
    const [lineData, setLineData] = useState([]);
    const dataFetchedRef = useRef(false);

    const transactionsCollectionRef = query(
        collection(db, "transactions"),
        where("uId", "==", currentUser.auth.currentUser.uid),
        orderBy("date", "desc")
    );

    let monthExpense;
    let monthlyExpenses = [];

    const setExpenseLineData = async () => {
        const data = await getDocs(transactionsCollectionRef);

        // get expense transactions
        let expenses = data.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(d => d.type === "Expense");
        expenses = expenses.sort((a,b) => moment(a.date).format('YYYYMMDD') - moment(b.date).format('YYYYMMDD'))

        // separate transactions by month
        for (const exp of expenses) {
            if (monthlyExpenses.find(m => m.month === moment(exp.date).format('MMM-YYYY'))) {                
                monthExpense = monthlyExpenses.find(m => m.month === moment(exp.date).format('MMM-YYYY'));
                monthExpense.amount += Number(exp.amount);
            } else {
                monthExpense = {
                    month: moment(exp.date).format('MMM-YYYY'),
                    amount: Number(exp.amount)
                }

                monthlyExpenses.push(monthExpense);
            }
        }

        setLineData(monthlyExpenses);
    };

    useEffect(() => {
        // useEffect keeps running twice due to React.StrictMode being on
        // discussed here: https://stackoverflow.com/questions/60618844/react-hooks-useeffect-is-called-twice-even-if-an-empty-array-is-used-as-an-ar
        // temporary workaround: https://upmostly.com/tutorials/why-is-my-useeffect-hook-running-twice-in-react#:~:text=This%20is%20because%20outside%20of,your%20hook%20has%20been%20ran.
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        setExpenseLineData();
    }, []);

    return (
        <>
            <h2>Monthly Expenses</h2>
            <h3><em>(To Date)</em></h3>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <LineChart
                width={500}
                height={400}
                data={lineData}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="amount" stroke="#dc3545" />
                </LineChart>
            </div>
        </>
      );
}

export { ExpenseLineChart };